<template>
  <div class="container transparent">
    <div class="row">
      <div class="col-md-6">
        <div class="vertical-container">
          <div class="header">
            <p>I don't have a Contentos account</p>
          </div>
          <div class="body">
            <router-link class="btn" to="accountname" tag="button">Create a new account</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="vertical-container">
          <div class="header">
            <p>I have a Contentos account</p>
          </div>
          <div class="body">
            <router-link class="btn" to="import" tag="button">Import an account</router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Choice'
}
</script>

<style lang="scss" scoped>
  @import "../../static/scss/variables";
  @import "../../static/scss/common";
  .vertical-container {
    width: 100%;
    max-width: 580px;
    height: 280px;
    background-color: #ffffff;
    text-align: center;
    box-shadow: 2px 4px 30px 0 rgba(0,39,170,0.16);
    border-radius: 8px;
    p {
      font-size: 24px;
      color: #000000;
      letter-spacing: 0;
    }
    .header {
      padding-top: 80px;
    }
    .body {
      padding-top: 59px;
    }
    .btn {
      width: 100%;
      max-width: 390px;
      height: 52px;
      margin: auto;
      display: block;
    }
  }

  @media (min-width: $bp-tablet-min) and (max-width: $bp-row-bleed-max) {
    .row {
      margin-left: 0;
      margin-right: 0;
    }
    // Heading may wrap to two lines here; pin the button to the bottom.
    .vertical-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 60px 20px 40px;
      .header,
      .body {
        padding-top: 0;
      }
    }
  }

  @media (max-width: $bp-mobile-max) {
    .vertical-container {
      height: auto;
      padding: 40px 20px;
      margin-bottom: 20px;
      p {
        font-size: 20px;
      }
      .header {
        padding-top: 0;
      }
      .body {
        padding-top: 24px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Choice.vue